export default __webpack_public_path__ + "static/media/books.7e83850d.png";